import { baseUrl } from '@/config/constants';

export const fetchReviews = async (tourId: string, page: number, controller: AbortController) => {
  const url = new URL(`${baseUrl}/tour/review/${tourId}`);
  const params = {
    page,
    size: 5,
    sort: ['string'],
  };

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((val) => url.searchParams.set(key, val));
    } else {
      url.searchParams.set(key, value.toString());
    }
  });

  const response = await fetch(url, { signal: controller.signal });
  const data = await response.json();

  if (controller.signal.aborted) {
    return [];
  }

  if (!response.ok) {
    throw new Error('Error fetching reviews data');
  }
  return data;
};
